import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getSettingsDetail } from "../Actions/ShippingSettings"
import logo from "../Asset/download.jpg";
import API from "../helpers/api";
import axios from "axios";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import { searchsettingsMgmt } from "../Actions/ShippingSettings"
import 'react-confirm-alert/src/react-confirm-alert.css';
import Role from "../helpers/role";

const SearchItem = {
  shipId: 0,
  ShipName: "",
  toMail: "",
  ccMail: "",
  PageNumber: 1,
  PageSize: 25,
};

let userRole = localStorage.getItem("UserRoles");

class ShippingSettingsDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",

    };

  }
  componentDidMount() {
    const { match, dispatch } = this.props;
    const { params } = match;
    const { id } = params;
    dispatch(getSettingsDetail(id));
  }
  componentDidUpdate() {
    const { dispatch, match } = this.props;
    window.onpopstate = (e) => {
      this.setState({ showSidePane: false });
      dispatch({ type: "ShowSidePan", data: false });
    };
  }
  ShowSidePanel = () => {
    this.setState({ showSidePane: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.goBack();
  };


  render() {
    const { settingsDetails } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row pt-4 pb-3"> </div>
          <div className="row pt-3">
            <div className="col-lg-12">
              <div className="resource-list-auth-date">
                <div className="panel-box search-filter-box">
                  <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                    onClick={() => this.ShowSidePanel()}
                  >
                    <div style={{ position: 'relative' }}>
                      <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Return</span>
                    </div>
                  </button>
                  <div
                    className="card mt-2 MM-card-header"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title m-2"
                        style={{ color: "092a51" }}
                      >
                        Settings Details
                      </h5>
                    </div>
                    <div className="pt-3 pb-3 search-filter-box">
                      <div className="row">
                        <div className="col-sm-12">
                          <label className="form-label">Ship Name :</label>
                          <span>
                            {" "}
                            {settingsDetails ? settingsDetails.shipName : ""}
                          </span>
                        </div>
                        <div className="col-sm-12">
                          <label className="form-label">To Email :</label>
                          <span>
                            {" "}
                            {settingsDetails ? settingsDetails?.toMail === null ? " " : settingsDetails?.toMail.length === 0 ? " " : settingsDetails?.toMail.length > 1 ? settingsDetails.toMail.reduce(function (a, b) {
                              return (a || a) + ", " + b
                            }) : settingsDetails?.toMail.map((i) => i.toString()) : ""}

                          </span>
                        </div>
                        <div className="col-sm-12">
                          <label className="form-label">
                            Cc Email :
                          </label>
                          <span>
                            {" "}
                            {settingsDetails ? settingsDetails?.ccMail === null ? " " : settingsDetails?.ccMail.length === 0 ? " " : settingsDetails?.ccMail.length > 1 ? settingsDetails.ccMail.reduce(function (a, b) {
                              return (a || a) + ", " + b
                            }) : settingsDetails?.ccMail.map((i) => i.toString()) : ""}

                          </span>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 pb-3 pt-3">
                      <div
                        className="search-btn-col mt-1"
                        style={{ textAlign: "right" }}
                      >
                        {userRole == Role.mmpl ? (<></>) : (<>
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.EditSettingsDetails(settingsDetails)}
                          >
                            {" "}
                            Edit{" "}
                          </button>
                        </>)}
                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button"
                          onClick={() => this.ShowSidePanel()}
                        >
                          {" "}
                          Cancel{" "}
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }

  EditSettingsDetails(item) {
    const { dispatch, history } = this.props;
    dispatch({ type: "SettingsUserDetails", data: item });
    history.push(`/Home/EditSettings/${item.shipId}`);
    dispatch({ type: "ShowSidePan", data: false });
  }


}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    settingsDetails: state.ShippingSettingsReducer.settingsDetails,

  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShippingSettingsDetail)
);
